import { addTab } from "@/utils";
import * as constant from "@/utils/constant";

const configArr = addTab(constant.newEntityInfo) || [];

export default [
  {
    name: "全部",
    path: "home"
  },
  {
    name: "优选生活",
    path: "life"
  },
  {
    name: "景点",
    path: "scenery"
  },
  {
    name: "玩乐",
    path: "tour"
  },
  {
    name: "影片",
    path: "movie"
  },
  {
    name: "蛋糕",
    path: "cake"
  },
  {
    name: "随心兑",
    path: "sxChange"
  },
  {
    name: "超市便利",
    path: "mart"
  },
  {
    name: "美食汇",
    path: "offline"
  },
  {
    name: "线下商户",
    path: "offline"
  },
  {
    name: "演出",
    path: "drama"
  },
  {
    name: "节日礼包",
    path: "spree"
  },
  {
    name: "影院",
    path: "cinema"
  },
  {
    name: "电子券",
    path: "coupon"
  },
  {
    name: "图书",
    path: "book"
  },
  {
    name: "京东优选",
    path: "jdyx"
  },
  {
    name: "小米有品",
    path: "xmyp"
  },
  {
    name: "网易严选",
    path: "wyyx"
  },
  {
    name: "东福超市",
    path: "chaoshi"
  },
  {
    name: "运动健身",
    path: "fitness"
  },
  {
    name: "健康商城",
    path: "healthy"
  },
  {
    name: "听书",
    path: "listen"
  },
  {
    name: "一企学",
    path: "study"
  },
  // {
  //   name: "体检套餐",
  //   path: "health"
  // },
  {
    name: "体检套餐",
    path: "examMeal"
  },
  {
    name: "体检机构",
    path: "examOrg"
  },
  {
    name: "口腔健康",
    path: "oralHealth"
  },
  {
    name: "健康服务",
    path: "healthServices"
  },
  {
    name: "酒店",
    path: "hotel"
  },
  {
    name: "亲子活动",
    path: "lxActivity"
  },
  {
    name: "亲子酒店",
    path: "lxHotel"
  },
  {
    name: "玩乐门票",
    path: "lxScenery"
  },
  ...configArr
];
